import Vue from 'vue'
import Router from 'vue-router'

import store from '../store/index'

Vue.use(Router)

const router =  new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: () => import('@pages/index/main.vue'),
            meta:{
               footer: 1,
               hidefooter:1,
            }
        },

        {
            path: '/company_profile',
            name: 'company_profile',
            component: () => import('@pages/company_profile/profile.vue'),
        },

        {
             path: '/service_introduction',
             name: 'service_introduction',
             component: () => import('@pages/service_introduction/index.vue'),

        },

        {
             path: '/core_strength',
             name: 'core_strength',
             component: () => import('@pages/core_strength/index.vue'),

        },

        {
            path: '/join_us',
            name: 'join_us',
            component: () => import('@pages/join_us/index.vue'),

        },

        {
            path: '/contact_us',
            name: 'contact_us',
            component: () => import('@pages/contact_us/index.vue'),

        },

        {
            path: '/news',
            name: 'news',
            component: () => import('@pages/news/index.vue'),
            meta:{
                header: 1,
                belong : 'news',
                // hidefooter:0,
            }
        },
        {
              path: '/news_info/:article_id',
              name: 'news_info',
              component: () => import('@pages/news/info.vue'),
              meta:{
                  header: 1,
                  belong : 'news',
                  hidefooter : 0,
              }
        }
    ]
});



router.beforeEach((to , from , next) => {
      window.scrollTo(0 , 0);

      if(to.meta.hidefooter == 0){
          store.commit('isShow_footer' , false);
      }  else {
          store.commit('isShow_footer' , true);
      }

      if(to.meta.footer == 1) {
           store.commit('change_footer' , true);
      } else {
           store.commit('change_footer' , false);
      }


      if(to.meta.header == 1) {
          window.onscroll = '';
          store.commit('change_header' , true);

      } else {
        window.onscroll = function (e) {
          let top = document.documentElement.scrollTop || document.body.scrollTop;

          if(top > 80) {
            store.commit('change_header' , true);
          }else {
            store.commit('change_header' , false);
          }
        }
      }


     next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js